<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Staff Attendance Punch</h5>
        </div>
        <div class="col-8 col-sm-6 text-right"></div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.insertable">
      <div class="col-xs-12 col-lg-6">
        <div class="card">
          <div class="card-body" style="text-align:center;margin-top:5%;margin-bottom:5%">
            <a-spin :spinning="loading">
              <template>
                <a-form :form="form">
                    <div class="row justify-content-center">
                        <div class="col col-md-auto">
                            <h4><b>{{ moment(new Date()).format('ddd, DD MMMM YYYY') }}</b></h4>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col col-md-auto">
                            <h3><b>{{ currentTime }}</b></h3>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col col-md-auto col-lg-6">
                            <a-form-item label="">
                                <a-input style="text-align: center;" placeholder="Staff Id" size="large" v-decorator="['staffid', { rules: [{ required: true, message: 'Please input staff id'}]}]"></a-input>
                            </a-form-item>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col col-md-auto col-sm-6">
                           <a-button type="primary" class="col-sm-12" @click="handleSubmit" size="large" html-type="submit" style="display:block;">Punch In</a-button>
                        </div>
                        <div class="col col-md-auto col-sm-6">
                           <a-button type="danger" class="col-sm-12" @click="handleSubmit" size="large" html-type="submit" style="display:block;">Punch Out</a-button>
                        </div>
                    </div>
                </a-form>
              </template>
            </a-spin>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'WebPunch',
  data: function () {
    return {
      currentTime: moment(new Date()).format('hh:mm:ss A'),
      loading: false,
      form: this.$form.createForm(this, { name: 'attendanceform' }),
      notifyme: false,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('staffattendance', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  watch: {
    notifyme(n, o) {
      console.log('reached and reacted', n)
    },
  },
  mounted: function() {
    setInterval(() => { this.currentTime = moment(new Date()).format('hh:mm:ss A') }, 1000)
    window.http = this.$http
    window.notify_local = this.$notification
    window.notify_icon = function (defO) {
      this.$notification.open(defO)
    }
  },
  methods: {
    moment,
    handleSubmit: async function(e) {
      console.log(e.target.innerText)
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values from form..', values)
          window.http.get(`/api/staff/model/withsystemstaffid?system_staff_id=${values.staffid}`)
            .then((res) => {
              console.log('receive data from server', res.data)
              if (res.data.data.length === 0) {
                this.$notification.open({
                  message: 'Staff Id Not Found',
                  description: 'Staff Id was not found in the record',
                }) // end notification
              } else {
                // open modalbox
                // console.log('opening modal')
                // console.log('checking again', res.data)
                var { first_name, last_name, staff_id } = { ...res.data.data }
                var ss_id = values.staffid
                var state = e.target.innerText === 'Punch In' ? 'IN' : 'OUT'
                this.$confirm({
                  title: 'Is this data correct for the staff?',
                  content: h => <div> <div><label style="width: 100px; ">Staff Code: </label> <label>{ staff_id }</label></div>
                    <div><label style="width: 100px; ">Staff Name: </label> <label style="text-transform: uppercase;">{ first_name + ' ' + last_name }</label></div></div>,
                  okText: 'Yes, this is correct',
                  cancelText: 'Cancel',
                  onOk: function() {
                    console.log('state', state)
                    let readydata = { system_staff_id: ss_id, punch_type: state, service_device_id: 'SKLSYNC019' }
                    console.log('readydata', readydata)
                    axios.post(`${process.env.VUE_APP_SERVER_URL}/api/staff/attendance/web/punch`, readydata,
                      {
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('access_token')}` },
                      }).then(function (data) {
                      console.log('server response POST ', data)
                      if (data.status === 200) {
                        window.notify_local.open({
                          message: 'Data logged',
                          description: 'Attendance data logged successfully',
                        })
                      }

                      if (data.data.status === 'success') {
                        window.notify_local.open({
                          message: 'Success',
                          description: 'Attendance data logged successfully',
                        })
                      }
                    }) // end then
                      .catch(error => {
                        // notification
                        console.log('ERROR', error.response.status)
                        if (error.response.status === 422) {
                          // window.notify_icon('error', { message: 'Invalid Check In/Out', description: 'Please check your Check In/Out status.' })
                          window.notify_local.open({ message: 'Invalid Check In/Out', description: 'Please check your Check In/Out status.' })
                        }
                      }) // end catch
                    // this.$http.get('google.com')
                  }, // end okfn
                  onCancel: function() {}, // end cancel
                }) // end modalbox
              }
            }) // end then
          // if (e.target.innerText === 'Punch In') {

          // }else if(e.target.innerText === 'Punch Out') { }
        }
      })
    },
  },
}
</script>

<style>

</style>
